import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import 'amfe-flexible/index.js'



import {
	Button,
	Loading,
	Swipe,
	SwipeItem,
	Lazyload,
	PullRefresh,
	Collapse,
	CollapseItem,
	Tag,
	Popup,
	NavBar,
	ShareSheet,
	
} from 'vant';

import { Image as VanImage } from 'vant';
Vue.use(Button).use(Loading).use(Swipe).use(SwipeItem).use(Lazyload).use(PullRefresh).use(Collapse).use(CollapseItem).use(
	Tag).use(Popup).use(NavBar).use(ShareSheet).use(VanImage )


/*自定义扩展方法*/
import Util from './lib/util';
import httpApi from './lib/httpApi'
import HttpRequest from './lib/httpRequest'
import HttpCache from './lib/localStorage'
import uniHelper from './lib/uniapp.js'
Vue.prototype.$api = httpApi
Vue.prototype.$Request = HttpRequest
Vue.prototype.$SysCache = HttpCache
Vue.prototype.$Helper = Util

import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';

NutUI.install(Vue);


// 全局挂在UNI 
global.suni = uniHelper;

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
	HttpRequest.parseToken(to.query);
	if (to.meta.isApp && !suni.isApp) {
		Util.titleMeta("首页");
		next({
			path: "/"
		})
	} else {
		uniHelper.showLoading({
			message: "加载中...",
			duration: 0
		})
		Util.titleMeta(to.meta);
		next();
	}
});

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
	uniHelper.hideLoading();
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
